export const carePlanRouteDef = [
    {
        path: 'care-plan',
        component: 'CarePlanComponent',
        data: {
            selector: 'app-care-plan'
        }
    },
    {
        path: ':id/care-plan-view',
        component: 'CarePlanComponent',
        data: {
            selector: 'app-care-plan'
        }
    },
    {
        path: ':id/care-plan-upgrade',
        component: 'CarePlanComponent',
        data: {
            selector: 'app-care-plan'
        }
    },
]